import { decrypted } from './util/CryptoUtil'

export const isAuthenticated = () => {
    if (localStorage.getItem(process.env.REACT_APP_TOKENUSER) !== null) {
        return true;
    }
    return false;
};

export const hasPermission = (permissions) => {
    let permitir = false
    try {
        const roleEncrypt = localStorage.getItem(process.env.REACT_APP_ROLEUSER)
        const roleDecrypt = decrypted(roleEncrypt)
        if (roleDecrypt !== null && roleDecrypt !== '') {
            for (let y in permissions) {
                if (roleDecrypt === permissions[y]) {
                    permitir = true
                }
            }
        }
        return permitir;
    } catch (e) {
        return permitir;
    }
};